<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <v-row
      v-if="currInstallationState"
      no-gutters
      class="fill-height">
      <v-col cols=2 class="fill-height">
        <v-sheet
            height="100vh"
            width="100vw"
            class="whitespace fill-height fill-width"
            @click="close()"
          >
        </v-sheet>
      </v-col>
      <v-col cols=10 class="sideview" height="200px">
          <v-sheet
            elevation="3"
            height="100vh"
            width="100vw"
            class="sideview fill-height fill-width"
          >
              <v-row
                class="px-6 pt-2 fill-height">
                <v-col cols=10 class="pt-2 pb-12 fill-height">
                  <div class="d-flex">
                    <div class="d-inline pa-2 ml-auto">
                      <TheMiniLoader :loading="isLoading" />
                    </div>
                    <v-btn
                      icon
                      color="textColor"
                      class="ml-4"
                      @click="refreshData"
                    >
                      <v-icon>mdi-autorenew</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="textColor"
                      @click="close"
                    >
                      <v-icon>mdi-window-close</v-icon>
                    </v-btn>
                  </div>
                    <span class="title grayBold--text">
                      {{ $t("installation") }}
                    </span>
                    <v-list-item two-line>
                      <v-list-item-avatar
                        tile
                        size=60
                       >
                          <!-- <v-icon large color="grayBold">
                            mdi-home-city-outline
                          </v-icon> -->
                          <v-img :src="require('@/assets/img/home_icon.png')"/>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="overline pl-2 mb-1 titleGrey--text">{{ $t("tag") }}</v-list-item-title>
                        <v-list-item-subtitle class="subtitle-1 pl-2 titleGrey--text">{{ tagId }}</v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <v-btn
                            small
                            light
                            elevation="0"
                            class="titleGrey--text"
                            @click="editInstallation"
                          >
                            <v-icon color="primary" left>
                              mdi-pencil
                            </v-icon>
                            {{$t("edit_for_uppercase")}}
                          </v-btn>
                          <v-btn
                            small
                            light
                            elevation="0"
                            class="titleGrey--text"
                            @click="deleteInstallation"
                          >
                            <v-icon color="primary" left>
                              mdi-delete
                            </v-icon>
                            {{$t("delete_for_uppercase")}}
                          </v-btn>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <div>
                        <v-chip
                          v-if="isPremium"
                          class="ma-2 chip"
                          color="success"
                          input-value="1"
                          outlined
                          small>
                          <v-icon
                            left
                            small>mdi-star-box-outline</v-icon>{{ $t("premium") }}
                        </v-chip>
                      </div>
                      </v-list-item-action>
                    </v-list-item>
                  <!-- <v-divider light></v-divider> -->
                  <v-tabs 
                    v-model="currTab"
                    color="primary"
                    show-arrows
                    background-color="transparent"
                    class="tabs" light>
                    <v-tab>{{ $t("general") }}</v-tab>
                    <v-tab>{{ $t("devices_uppercase") }}</v-tab>
                  </v-tabs>
  
                  <v-tabs-items v-model="currTab">
                    <v-tab-item light key=0>
                      <InstallationsSideviewGeneralTab v-show="currTab == 0" :installation="currInstallation"/>
                    </v-tab-item>
                    <v-tab-item light key=1>
                      <InstallationsSideviewDevicesTab v-show="currTab == 1" :installation="currInstallation"/>
                    </v-tab-item>
                  </v-tabs-items>
                    <v-divider class="mx-4 mt-2"/>
                    <v-list-item class="pt-12">
                      <v-list-item-content>
                        <v-list-item-title class="overline textColor2--text">
                          {{ $t("created_uppercase") }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="pt-1 textColor2--text"> {{ formatDate(currInstallation.info.created_at) }} {{$t("by")}} {{currInstallation.info.created_by}}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content class="ml-6">
                        <v-list-item-title class="overline textColor2--text">
                          {{ $t("updated_uppercase") }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="pt-1 textColor2--text"> {{ formatDate(currInstallation.info.updated_at) }} {{$t("by")}} {{currInstallation.info.updated_by}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                </v-col>
              </v-row>
          <LoadingIndicator :loading="loading" />
          </v-sheet>
      </v-col>
    </v-row>
  </template>
  
  <script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { commonModule, installationsModule, companyModule, statsModule, clientsModule, filterModule } from '@/store/modules/store-accessor'
  import LoadingIndicator from '@/components/TheLoadingIndicator.vue'
  import InstallationsSideviewGeneralTab from '@/components/sideviews/installations/InstallationsSideviewGeneralTab.vue'
  import InstallationsSideviewDevicesTab from '@/components/sideviews/installations/InstallationsSideviewDevicesTab.vue'
  import { TimeUtil } from '@/helpers/TimeUtil'
  import FileSaver from 'file-saver';
  import dayjs from 'dayjs';
  import TheMiniLoader from '@/components/TheMiniLoader.vue'
  import _ from 'lodash';
import { install } from 'vue2-google-maps'

  @Component({
    components: {
      LoadingIndicator,
      InstallationsSideviewGeneralTab,
      InstallationsSideviewDevicesTab,
      TheMiniLoader
    }
  })
  export default class InstallationsSideview extends Vue {
    @Prop()
    loading!: boolean;
  
    @Prop()
    payload!: any;
    
    currTab = this.payload?.tab || 0;
    jobId = this.payload?.jobId || 0;
    appointmentId = this.payload?.appointmentId || 0;
    taskId = this.payload?.taskId || 0;
  
    isEditing!: boolean;
  
    async hideSideview () {
      commonModule.hideSideview();
    }
  
    get currInstallationId () {
      return this.payload?.installationId;
    }
  
    get currInstallation () {
      return installationsModule.currentInstallation;
    }
  
    get exportPDFEnabled () {
      //TODO Ths is quick and dirty, we need to change this and implement it thourgh feature flags
      return companyModule.company.key == 'GSOP' ? true : false
    }
  
    formatDate (date: Date): string {
      return TimeUtil.formatDateTime(date)
    }
  
    updated() {
      this.isEditing = false;
    }
  
    get isLoading() {
      return installationsModule.isLoadingSideView;
    }
  
    get isPremium () {
      return installationsModule.currentInstallation.info.is_premium;
    }
  
    get tagId () {
      return (installationsModule.currentInstallation.info.tag_id).split("_").pop();
    }

    get currInstallationState() {
        return !(_.isEmpty(this.currInstallation))
    }
  
    refreshData () {
      installationsModule.setIsLoadingSideView(true);
      installationsModule.getInstallationInfo(this.currInstallationId);
      installationsModule.getInstallationDevices(this.currInstallationId);
    }
  
    async editInstallation() {
      await installationsModule.getInstallationInfo(this.currInstallationId);
      commonModule.showModal({ name: 'edit-installation-modal', payload: { view: "installationsSideview"}})
    }
  
    deleteInstallation() {
      commonModule.showModal({ name: 'delete-installation-modal', payload: { installation: this.currInstallation.info}})
    }
  
    close () {
      installationsModule.unsetCurrentInstallation();
  
      switch(this.$route.name) {
        case 'Dashboard':
          break;
        case 'Installations':
          installationsModule.getInstallationsAction(installationsModule.filters);
          break;
        case 'Map':
          installationsModule.getInstallationsAction(installationsModule.filters);
          break;
      }
      this.hideSideview()
    }
  
  };
  </script>
  
  <style scoped lang="scss">
  
  .sideview {
    background-color:whitesmoke;
    max-height: 100vh !important;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  .tabs {
    background: $whitesmoke;
    color:transparent;
  }
  
  .title {
    margin-top: 5px;
    font-size: 35;
    font-weight: 500;
  }
  
  h2 {
    color: $dark-blue-grey;
  }
  
  span {
    margin-left: 10px;
    font-size: 1.5rem !important;
    font-weight: 400;
    color: $pale-purple;
  }
  
  .close-btn {
    color: $card-title-color;
  }
  
  .loading {
    margin: 5px;
    right: 1px;
  }
  
  .chip {
    font-size: 12px !important;
  }
  
  .whitespace {
    width: 100%;
    height: 100%;
    background-color:transparent;
  }
  
  
  /* Hide overflow-y scrollbar */
  ::-webkit-scrollbar {
    width: 0.5em;
  }
  
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  
  .element-with-scrollbar {
    overflow-y: auto;
    scrollbar-width: thin;
  }
  
  .element-with-scrollbar::-webkit-scrollbar {
    width: 0.5em;
  }
  
  .element-with-scrollbar::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  </style>
  